export enum ButtonType {
  PLAY = 'play',
  BUY = 'buy',
}
